import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import http from '../../Api/http';
import Util from '../../Util';
import { encryptPassword } from '../../RsaEncryptor';

export const ChangePasswordModal = ({ isOpen, onClose }) => {
    const txtCurrPwd = useRef();
    const txtNewPwd = useRef();
    const txtConfirmPwd = useRef();
    const { t } = useTranslation();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        CurrentPwd: '',
        NewPwd: '',
        ConfirmPwd: '',
    });

    const [successMessage, setSuccessMessage] = useState("");
    const [failedMessage, setFailedMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setErrors(prev => ({ ...prev, [name]: '' }));
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        let newErrors = {};
        let allowFocus = true;
        if (!formData.CurrentPwd) {
            if (allowFocus) {
                allowFocus = false;
                txtCurrPwd.current.focus();
            }
            newErrors.CurrentPwd = t('requiredField');
        }
        if (!formData.NewPwd) {
            if (allowFocus) {
                allowFocus = false;
                txtNewPwd.current.focus();
            }
            newErrors.NewPwd = t('requiredField');
        }
        if (!formData.ConfirmPwd) {
            if (allowFocus) {
                allowFocus = false;
                txtConfirmPwd.current.focus();
            }
            newErrors.ConfirmPwd = t('requiredField');
        }
        if (formData.NewPwd !== formData.ConfirmPwd) {
            newErrors.NewPwd = t('passwordsNotMatch');
            if (allowFocus) {
                allowFocus = false;
                txtNewPwd.current.focus();
            }
        }

        return newErrors;
    };

    const onSave = async (e) => {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        const passwordError = Util.validatePassword(formData.NewPwd, t);
        if (passwordError) {
            setFailedMessage(passwordError);
            setTimeout(() => setFailedMessage(""), 3000);
            return;
        }

        try {
            let obj = {
                CurrPwd: encryptPassword(formData.CurrentPwd),
                NewPwd: encryptPassword(formData.NewPwd)
            }
            const result = await http.postJsonAxios(http.actions.Auth.ChangePwd, obj, t);
            if (result.status === 200 && result.data.success) {
                onClose();
                setSuccessMessage(t('done'));
                setTimeout(() => setSuccessMessage(""), 3000);

            } else {
                setFailedMessage(result.data.errorText || t('failed'));
                setTimeout(() => setFailedMessage(""), 3000);
            }
        }
        catch (e) {

        }
        finally {
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-md w-full max-w-sm sm:max-w-md p-4 sm:p-6 mx-4">
                <h2 className="text-lg font-bold mb-4 text-center">{t('changePwd')}</h2>
                {successMessage && (
                    <div className="bg-green-100 text-green-800 p-2 rounded mb-2 text-center border border-green-400">
                        {successMessage}
                    </div>
                )}
                {failedMessage && (
                    <div className="bg-red-100 text-red-800 p-2 rounded mb-2 text-center border border-red-400">
                        {failedMessage}
                    </div>
                )}
                <div className="space-y-4">
                    <div>
                        <label className="block font-medium mb-1">{t('currPwd')}</label>
                        <input ref={txtCurrPwd} required autoFocus name='CurrentPwd' type="password"
                            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                            value={formData.CurrentPwd} onChange={handleChange}

                        />
                        {errors.CurrentPwd && (<p className="text-red-500 text-sm mt-1">{errors.CurrentPwd}</p>)}
                    </div>
                    <div>
                        <label className="block font-medium mb-1">{t('newPwd')}</label>
                        <input ref={txtNewPwd} name='NewPwd' type="password"
                            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                            value={formData.NewPwd} onChange={handleChange}
                            required
                        />
                        {errors.NewPwd && (<p className="text-red-500 text-sm mt-1">{errors.NewPwd}</p>)}
                    </div>
                    <div>
                        <label className="block font-medium mb-1">{t('confirmPwd')}</label>
                        <input ref={txtConfirmPwd} type="password" name='ConfirmPwd'
                            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-blue-500 outline-none"
                            value={formData.ConfirmPwd} onChange={handleChange}
                            required
                        />
                        {errors.ConfirmPwd && (<p className="text-red-500 text-sm mt-1">{errors.ConfirmPwd}</p>)}
                    </div>
                    <div className="flex flex-col sm:flex-row justify-end gap-2 pt-2">
                        <button type="button" onClick={(e) => onSave(e)}
                            className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 outline-none">
                            {t('save')}
                        </button>
                        <button type="button" onClick={onClose}
                            className="w-full sm:w-auto px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 focus:ring-2 focus:ring-blue-500 outline-none"
                        >
                            {t('cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
